import { useQuery } from "react-query";
import { getDeactivatedAgreementsCount } from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useDeactivatedAgreementCount = () => {
  return useQuery(
    "GetDeactivatedAgreementCount",
    getDeactivatedAgreementsCount,
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useDeactivatedAgreementCount;
